import React, { useEffect } from "react";

const DateCalculator = () => {
  function Calculator() {
    // Conversion du format de saisie de la date du jour
    // toISOString pour n'avoir que des chiffres
    // split permet de casser au "T" situé entre la date et l'heure et de transformer en tableau de 2 éléments (0 et 1)
    // Je ne m'intéresse qu'au 0, le 1 étant l'heure

    const today = new Date().toISOString().split("T")[0];
    const start_date = document.getElementById("start_date");
    const end_date = document.getElementById("end_date");
    const totalForNights = document.getElementById("total");
    const nightPrice = document.getElementById("nightPrice");

    // Je donne ma valeur à l'input
    start_date.value = today;
    // Pour bloquer la sélection de dates du passé
    start_date.min = today;

    // Calcul de la date du lendemain : date du jour+1
    let tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    // Conversion au bon format, que l'on passe ensuite à l'input
    let tomorrowFormat = tomorrow.toISOString().split("T")[0];
    end_date.value = tomorrowFormat; // Pour bloquer la sélection de dates du passé
    end_date.min = tomorrowFormat;

    // J'ajoute un événement qui met automatiquement une date de fin supérieur de 1 jour à la date de début

    start_date.addEventListener("change", (e) => {
      let day = new Date(e.target.value);

      if (end_date.value < start_date.value) {
        day.setDate(day.getDate() + 1);
        end_date.value = day.toISOString().split("T")[0];
      }
    });
    // J'ajoute un événement pour empêcher la sélection d'une date de fin inférieure à la date de début
    end_date.addEventListener("change", (e) => {
      let day = new Date(e.target.value);

      if (end_date.value < start_date.value) {
        day.setDate(day.getDate() - 1);
        start_date.max = day.toISOString().split("T")[0];
      }
    });
    // Calcul du prix de la réservation (valeur de fin - valeur de début à partir d'un timestamp)
    // Math.abs pout "absolu"
    const bookingClac = () => {
      let diffTime = Math.abs(
        new Date(end_date.value) - new Date(start_date.value)
      );
      // Je transforme mon timestamp en jours ( 1000 ramène en secondes, 60 en minutes, puis 60 pour les heures, puis 24 pour les jours)
      // Math.ceil pour arrondir au supérieur
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      // Calculer le prix
      totalForNights.textContent = diffDays * nightPrice.textContent;
    };
    // Pour jouer la fonction à chaque fois que les inputs sont bougés
    start_date.addEventListener("change", bookingClac);
    end_date.addEventListener("change", bookingClac);

    // j'appelle la fonction pour la jouer
    bookingClac();
  }
  useEffect(Calculator);

  return (
    <div>
      <div className="page-container-datecalculator">
        <div className="card">
          <h2>Réserver vos vacances</h2>
          <div>
            <span id="nightPrice">46</span> € la nuit
          </div>

          <label htmlFor="">Début</label>
          {/* <input id="start_date" type="date" value={"today"} equired /> */}
          <input id="start_date" type="date" className="hover" />
          <label htmlFor="">Fin</label>
          <input id="end_date" type="date" className="hover" />

          <h4>
            Total : <span id="total"></span> €
          </h4>
          <button className="btn btn cyan accent-3">Validez</button>
        </div>
      </div>
    </div>
  );
};

export default DateCalculator;
